var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPermission({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.565,
    height: 63.498,
    viewBox: "0 0 46.565 63.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone_1_",
    "data-name": "microphone (1)",
    transform: "translate(-5 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13691",
    "data-name": "Path 13691",
    d: "M51.565,17.117A2.117,2.117,0,0,0,49.449,15H7.117A2.117,2.117,0,0,0,5,17.117,23.283,23.283,0,0,0,26.166,40.4v6.35a2.117,2.117,0,1,0,4.233,0V40.4A23.283,23.283,0,0,0,51.565,17.117ZM28.283,36.166A19.049,19.049,0,0,1,9.36,19.233H47.2A19.049,19.049,0,0,1,28.283,36.166Z",
    transform: "translate(0 15.632)",
    fill: "#393e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13692",
    "data-name": "Path 13692",
    d: "M37.166,15H16v4.233H34.922A19.049,19.049,0,0,1,16,36.166v12.7a2.117,2.117,0,0,0,2.117-2.117V40.4A23.283,23.283,0,0,0,39.283,17.117,2.117,2.117,0,0,0,37.166,15Z",
    transform: "translate(12.283 15.632)",
    fill: "#485961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13693",
    "data-name": "Path 13693",
    d: "M23.816,1A14.816,14.816,0,0,0,9,15.816V32.749a14.816,14.816,0,1,0,29.632,0V15.816A14.816,14.816,0,0,0,23.816,1Z",
    transform: "translate(4.466)",
    fill: "#769bef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13694",
    "data-name": "Path 13694",
    d: "M30.816,15.816V32.749a11.747,11.747,0,0,1-.169,2.117A14.816,14.816,0,0,1,16,47.565V1A14.816,14.816,0,0,1,30.816,15.816Z",
    transform: "translate(12.283)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13695",
    "data-name": "Path 13695",
    d: "M23.583,10.233H15.117a2.117,2.117,0,0,1,0-4.233h8.466a2.117,2.117,0,0,1,0,4.233Zm0,10.583H15.117a2.117,2.117,0,1,1,0-4.233h8.466a2.117,2.117,0,0,1,0,4.233Zm0,10.583H15.117a2.117,2.117,0,1,1,0-4.233h8.466a2.117,2.117,0,0,1,0,4.233Z",
    transform: "translate(8.933 5.583)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13696",
    "data-name": "Path 13696",
    d: "M22.35,8.117a2.117,2.117,0,0,1-2.117,2.117H16V6h4.233A2.117,2.117,0,0,1,22.35,8.117Zm0,10.583a2.117,2.117,0,0,1-2.117,2.117H16V16.583h4.233A2.117,2.117,0,0,1,22.35,18.7Zm0,10.583A2.117,2.117,0,0,1,20.233,31.4H16V27.166h4.233A2.117,2.117,0,0,1,22.35,29.283Z",
    transform: "translate(12.283 5.583)",
    fill: "#769bef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPermission);
export default __webpack_public_path__ + "static/media/audioPermission.440314a020b43a55345e7474b7c19c32.svg";
export { ForwardRef as ReactComponent };